var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loggedIn)?_c('v-container',[_c('v-card',[_c('v-img',{staticClass:"white--text",attrs:{"src":_vm.media,"aspect-ratio":16 / 9}}),_c('a-login-form',{attrs:{"prefilled-email":_vm.email}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }